import sendRequestAndGetResponse from './sendRequestAndGetResponse';

export const BASE_PATH = '/api/v1/public';

// Companies
export const getCompaniesApiMethod = (qs, headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/companies/list`, {
    method: 'GET',
    headers,
    qs,
  });

export const getAllCompaniesApiMethod = (headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/companies/list-all`, {
    method: 'GET',
    headers,
  });

export const getCompanyApiMethod = (companyId) =>
  sendRequestAndGetResponse(`${BASE_PATH}/companies/one-company`, {
    method: 'GET',
    qs: { companyId },
  });

export const getCompanyWithJobsAndNewsApiMethod = (companySlug, headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/companies/one-company-with-jobs-and-news`, {
    method: 'GET',
    qs: { companySlug },
    headers,
  });

//-----------------------------------------------------------------

// Jobs
export const getBatchOfJobsApiMethod = (categorySlug, companySlug, state, page, search, headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/jobs/batch`, {
    method: 'GET',
    headers,
    qs: { categorySlug, companySlug, state, page, search },
  });

export const getAnyBatchOfJobsApiMethod = (data) =>
  sendRequestAndGetResponse(`${BASE_PATH}/jobs/any-batch`, {
    method: 'GET',
    qs: { data },
  });

export const getJobAndCompanyApiMethod = (jobId, headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/jobs/job-and-company`, {
    method: 'GET',
    headers,
    qs: { jobId },
  });

//-------------------------------------------------------------------

export const subscribeToWeeklyUpdateApiMethod = ({ email }: { email: string }) =>
  sendRequestAndGetResponse('/auth/send-token', {
    body: JSON.stringify({
      user: email,
      isLoginEvent: false,
    }),
  });

export const sendEditLinkApiMethod = ({ email }: { email: string }) =>
  sendRequestAndGetResponse('/auth/send-token', {
    body: JSON.stringify({
      user: email,
      isLoginEvent: true,
    }),
  });

export const getPreferencesApiMethod = ({
  source,
  token,
  headers,
}: {
  source?: string;
  token: string;
  headers: any;
}) =>
  sendRequestAndGetResponse(`${BASE_PATH}/preferences/get`, {
    method: 'GET',
    headers,
    qs: { source, token },
  });

export const getUnsubscribeStatusApiMethod = ({ token }: { token: string }) =>
  sendRequestAndGetResponse(`${BASE_PATH}/unsubscribe-status`, {
    method: 'GET',
    qs: { token },
  });

export const editPreferencesApiMethod = ({
  userId,
  status,
  category,
  states,
  source,
}: {
  userId: string;
  status;
  category: string;
  states: string[];
  source?: string;
}) =>
  sendRequestAndGetResponse(`${BASE_PATH}/preferences/edit`, {
    body: JSON.stringify({
      userId,
      status,
      category,
      states,
      source,
      isLoginEvent: true,
    }),
  });

export const unsubscribeFromWeeklyUpdateApiMethod = ({ token }: { token: string }) =>
  sendRequestAndGetResponse(`${BASE_PATH}/unsubscribe`, {
    method: 'POST',
    body: JSON.stringify({ token }),
  });

export const getFeaturedApiMethod = (headers) =>
  sendRequestAndGetResponse(`${BASE_PATH}/featured`, {
    method: 'GET',
    headers,
  });

export const paymentFeaturedApiMethod = (data) =>
  sendRequestAndGetResponse(`${BASE_PATH}/featured/payment`, {
    body: JSON.stringify(data),
  });

export const uploadFileApiMethod = (formData) =>
  fetch(`${BASE_PATH}/upload-file`, {
    method: 'post',
    body: formData,
    credentials: 'include',
    headers: {
      'x-wib-signature': process.env.NEXT_PUBLIC_WIB_KEY,
    },
  });

export const sendApiRequest = ({
  path,
  data,
  method = 'POST',
}: {
  path: string;
  data?: any;
  method?;
}) =>
  sendRequestAndGetResponse(`${BASE_PATH}/${path}`, {
    method,
    body: data && JSON.stringify(data),
  });

export const readFile = (key: string) => `${BASE_PATH}/read-file?key=${key}`;
